import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {BlankState, Actions, StateChanges} from './stateChanges'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDQDLCIq5syV05gAZTkwwjXMHaQP5x17IA",
  authDomain: "dicta-nakdan.firebaseapp.com",
  databaseURL: "https://dicta-nakdan.firebaseio.com",
  projectId: "dicta-nakdan",
  storageBucket: "dicta-nakdan.appspot.com",
  messagingSenderId: "739874995267"
}

export function initializeFirebase (store) {
  firebase.initializeApp(config)
  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      // User is signed in.
      // const displayName = user.displayName
      // var email = user.email
      // var emailVerified = user.emailVerified
      // var photoURL = user.photoURL
      // var isAnonymous = user.isAnonymous
      // var uid = user.uid
      // var providerData = user.providerData
      store.dispatch(Actions.PROCESS_LOGIN)
    } else {
      // User is signed out.
      store.commit(StateChanges.LOGGED_OUT)
    }
  })
}

export const syncData = {
  // 'favorites': null,
  // 'recent': null,
  // 'savedExperiments': null
  'permissionToUseData': null,
  'dictionary': null
}

export function createFirebaseRefs () {
  const userId = firebase.auth().currentUser.uid
  for (const dataType in syncData) {
    syncData[dataType] = firebase.database().ref('/users/' + userId + '/' + dataType)
  }
}

export function firebaseLogout () {
  for (const dataType in syncData) {
    if (syncData[dataType]) {
      syncData[dataType].off()
    }
    syncData[dataType] = null
  }
  firebase.auth().signOut()
}

export function bindFirebaseRef (commitFunc, listName, ref) {
  ref.on('value', (snapshot) => {
    commitFunc('FIREBASE_RECEIVED_UPDATE', {listName, value: snapshot.val() || JSON.parse(JSON.stringify(BlankState.userDictionary))})
  })
}

export function firebaseStore (listName, data) {
  const ref = syncData[listName]
  if (ref) {
    ref.set(data)
  }
}
